const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIdentityVerification = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.542969 2.332031 L 1.457031 2.332031 C 0.65625 2.332031 0 2.988281 0 3.792969 L 0 10.207031 C 0 11.011719 0.65625 11.667969 1.457031 11.667969 L 12.542969 11.667969 C 13.34375 11.667969 14 11.011719 14 10.207031 L 14 3.792969 C 14 2.988281 13.34375 2.332031 12.542969 2.332031 Z M 13.417969 10.207031 C 13.417969 10.691406 13.023438 11.082031 12.542969 11.082031 L 1.457031 11.082031 C 0.976562 11.082031 0.582031 10.691406 0.582031 10.207031 L 0.582031 3.792969 C 0.582031 3.308594 0.976562 2.917969 1.457031 2.917969 L 12.542969 2.917969 C 13.023438 2.917969 13.417969 3.308594 13.417969 3.792969 Z M 13.417969 10.207031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 13.707031 4.082031 L 0.292969 4.082031 C 0.128906 4.082031 0 4.214844 0 4.375 L 0 6.125 C 0 6.285156 0.128906 6.417969 0.292969 6.417969 L 13.707031 6.417969 C 13.871094 6.417969 14 6.285156 14 6.125 L 14 4.375 C 14 4.214844 13.871094 4.082031 13.707031 4.082031 Z M 13.417969 5.832031 L 0.582031 5.832031 L 0.582031 4.667969 L 13.417969 4.667969 Z M 13.417969 5.832031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.542969 8.167969 L 2.042969 8.167969 C 1.878906 8.167969 1.75 8.296875 1.75 8.457031 C 1.75 8.621094 1.878906 8.75 2.042969 8.75 L 5.542969 8.75 C 5.703125 8.75 5.832031 8.621094 5.832031 8.457031 C 5.832031 8.296875 5.703125 8.167969 5.542969 8.167969 Z M 5.542969 8.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.542969 9.332031 L 2.042969 9.332031 C 1.878906 9.332031 1.75 9.464844 1.75 9.625 C 1.75 9.785156 1.878906 9.917969 2.042969 9.917969 L 5.542969 9.917969 C 5.703125 9.917969 5.832031 9.785156 5.832031 9.625 C 5.832031 9.464844 5.703125 9.332031 5.542969 9.332031 Z M 5.542969 9.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.375 7.582031 L 10.792969 7.582031 C 10.308594 7.582031 9.917969 7.976562 9.917969 8.457031 L 9.917969 9.042969 C 9.917969 9.523438 10.308594 9.917969 10.792969 9.917969 L 11.375 9.917969 C 11.859375 9.917969 12.25 9.523438 12.25 9.042969 L 12.25 8.457031 C 12.25 7.976562 11.859375 7.582031 11.375 7.582031 Z M 11.667969 9.042969 C 11.667969 9.203125 11.535156 9.332031 11.375 9.332031 L 10.792969 9.332031 C 10.628906 9.332031 10.5 9.203125 10.5 9.042969 L 10.5 8.457031 C 10.5 8.296875 10.628906 8.167969 10.792969 8.167969 L 11.375 8.167969 C 11.535156 8.167969 11.667969 8.296875 11.667969 8.457031 Z M 11.667969 9.042969 "
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIdentityVerification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/identity-verification.83d17d275c730961e645b25a6193c3df.svg";